module.exports = __webpack_public_path__ + "media/images/official/top_mv3_sp-e164dce3f50be3b5324a158f5dc0eef6.jpg";